import api from '@/services/api'
export default (Email, Password) => new Promise((resolve, reject) => api().post('/webshop/auth/login', {
    email: Email,
    password: Password,

}).then(e => {
    resolve(e.data)
}).catch(e => {
    reject(e.response.data)
}))